var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"https://t.me/+fdjvdHy378I1MzI0"}},[_c('i',{staticClass:"fab fa-telegram icon"})])}]

export { render, staticRenderFns }